export default "__VITE_ASSET__BPHmL2zR__"